import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans'
import * as fn from "../../../../helper/uiFunctions";
import SarasTooltip from '../../../../library/notifications/SarasTooltip';

const DocQCStatus = (props) => {
    const { formObject, viewData } = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    const qStatusHidden = formObject.getValueFromKey(viewData, "dataList.qStatusHidden", "1");
    const qStatusVal = formObject.getValueFromKey(viewData, "dataList.qStatusVal", "");
    const qStatusStyle = JSON.parse(formObject.getValueFromKey(viewData, "dataList.qStatusStyle", "{}"));

    let statusCount = 0;

    if (fn.compareNumber(qStatusHidden, 0)) statusCount++;

    const renderQcStatus = () => {
        if (fn.compareNumber(qStatusHidden, 0)){
            return (
                <SarasTooltip title={<><SarasTrans value='QC Status' />: <SarasTrans value={qStatusVal} /></>}>
                    <span className="uiStatusCompactDocument" style={qStatusStyle}>Q</span>
                </SarasTooltip>
            )
        }
        else{
            return null
        }
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass} style={{margin: '0px auto', width:`${27 * statusCount}px`}}>
                {renderQcStatus()}
            </div>
        </div >
    )
}

export default DocQCStatus
